var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/inherits");

var Bluebird = require('bluebird');

var Transaction = require('../../transaction');

var _require = require('lodash'),
    isUndefined = _require.isUndefined;

var debug = require('debug')('knex:tx');

module.exports =
/*#__PURE__*/
function (_Transaction) {
  "use strict";

  _inherits(Transaction_MSSQL, _Transaction);

  function Transaction_MSSQL() {
    _classCallCheck(this, Transaction_MSSQL);

    return _possibleConstructorReturn(this, _getPrototypeOf(Transaction_MSSQL).apply(this, arguments));
  }

  _createClass(Transaction_MSSQL, [{
    key: "begin",
    value: function begin(conn) {
      debug('%s: begin', this.txid);
      return conn.tx_.begin().then(this._resolver, this._rejecter);
    }
  }, {
    key: "savepoint",
    value: function savepoint(conn) {
      var _this = this;

      debug('%s: savepoint at', this.txid);
      return Bluebird.resolve().then(function () {
        return _this.query(conn, "SAVE TRANSACTION ".concat(_this.txid));
      });
    }
  }, {
    key: "commit",
    value: function commit(conn, value) {
      var _this2 = this;

      this._completed = true;
      debug('%s: commit', this.txid);
      return conn.tx_.commit().then(function () {
        return _this2._resolver(value);
      }, this._rejecter);
    }
  }, {
    key: "release",
    value: function release(conn, value) {
      return this._resolver(value);
    }
  }, {
    key: "rollback",
    value: function rollback(conn, error) {
      var _this3 = this;

      this._completed = true;
      debug('%s: rolling back', this.txid);
      return conn.tx_.rollback().then(function () {
        var err = error;

        if (isUndefined(error)) {
          if (_this3.doNotRejectOnRollback) {
            _this3._resolver();

            return;
          }

          err = new Error("Transaction rejected with non-error: ".concat(error));
        }

        _this3._rejecter(err);
      }, function (err) {
        if (error) err.originalError = error;
        return _this3._rejecter(err);
      });
    }
  }, {
    key: "rollbackTo",
    value: function rollbackTo(conn, error) {
      var _this4 = this;

      debug('%s: rolling backTo', this.txid);
      return Bluebird.resolve().then(function () {
        return _this4.query(conn, "ROLLBACK TRANSACTION ".concat(_this4.txid), 2, error);
      }).then(function () {
        return _this4._rejecter(error);
      });
    } // Acquire a connection and create a disposer - either using the one passed
    // via config or getting one off the client. The disposer will be called once
    // the original promise is marked completed.

  }, {
    key: "acquireConnection",
    value: function acquireConnection(config) {
      var t = this;
      var configConnection = config && config.connection;
      return new Bluebird(function (resolve, reject) {
        try {
          resolve((t.outerTx ? t.outerTx.conn : null) || configConnection || t.client.acquireConnection());
        } catch (e) {
          reject(e);
        }
      }).then(function (conn) {
        conn.__knexTxId = t.txid;

        if (!t.outerTx) {
          t.conn = conn;
          conn.tx_ = conn.transaction();
        }

        return conn;
      }).disposer(function (conn) {
        if (t.outerTx) return;

        if (conn.tx_) {
          if (!t._completed) {
            debug('%s: unreleased transaction', t.txid);
            conn.tx_.rollback();
          }

          conn.tx_ = null;
        }

        t.conn = null;

        if (!configConnection) {
          debug('%s: releasing connection', t.txid);
          t.client.releaseConnection(conn);
        } else {
          debug('%s: not releasing external connection', t.txid);
        }
      });
    }
  }]);

  return Transaction_MSSQL;
}(Transaction);